import { Carousel } from 'react-responsive-carousel';
import { useTheme } from '@emotion/react';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { Image } from '../picture/picture';
import { Image as ImageTypes } from '../../models/image';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

interface ImagesSliderTypes extends ImageTypes {
  is_main: boolean;
}

export function CompilationSlider({
  images,
  compilation,
}: {
  images?: readonly ImagesSliderTypes[];
  compilation: { title: string };
}) {
  const theme = useTheme();
  const mapSlides = () => {
    if (!images || images.length === 0) {
      return [];
    }

    return images
      .filter((item) => !item.is_main)
      .map((slide, index) => (
        <div
          key={slide.id}
          css={{
            width: '100%',
            height: '570px',
            position: 'relative',
            color: theme.colors.textWhite,
            transition: 'opacity .5s ease',
            borderRadius: '0 0 4px 4px',
            overflow: 'hidden',
            img: {
              position: 'absolute',
              bottom: 0,
              right: 0,
              overflow: 'hidden',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              maxWidth: '100%',
              height: '100%',
              objectFit: 'cover',
            },
            [DEVICE_SCREENS_MAX_STRING.lg]: {
              height: '317px',
            },
            [DEVICE_SCREENS_MAX_STRING.md]: {
              height: '384px',
              img: {
                objectFit: 'cover',
                height: '100%',
                top: 0,
                left: 0,
                transform: 'none',
              },
            },
          }}
        >
          <Image
            key={`img__${slide.id}`}
            image={slide}
            loading={index === 0 ? 'eager' : 'lazy'}
            alt={compilation.title}
          />
          <div
            css={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background:
                'linear-gradient(180deg, rgba(19, 19, 19, 0) 25.52%, #131313 100%)',
              zIndex: 1,
            }}
          />
        </div>
      ));
  };
  return (
    <div
      css={{
        marginBottom: '3rem',
      }}
    >
      <Carousel
        css={{
          overflow: 'hidden',
          maxHeight: '570px',
          display: 'flex',
          borderRadius: '0 0 4px 4px',
          boxShadow: '0 0 5px #ccc',
          border: '5px solid #fff',
          [DEVICE_SCREENS_MAX_STRING.lg]: {
            maxHeight: '317px',
          },
          [DEVICE_SCREENS_MAX_STRING.md]: {
            maxHeight: '396px',
          },
        }}
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        showArrows={false}
      >
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        {mapSlides()}
      </Carousel>
    </div>
  );
}
